import { UserData, reduxUserAction } from "../types";

export const updateUser = (data: UserData): reduxUserAction => {
  return {
    type: "UPDATE_USER",
    payload: data
  };
};
